import axios from 'axios';
import store from '../Redux';
import { clearUserDetails } from '../Redux/userSlice';
import { clearCompanyDetails } from '../Redux/companySlice';

// Create axios instance with base URL
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// Request interceptor to add token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle token expiration
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear local storage
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      localStorage.removeItem('userId');
      localStorage.removeItem('company');

      // Clear Redux store for both user and company
      store.dispatch(clearUserDetails());
      store.dispatch(clearCompanyDetails());

      // Redirect to login page with expired parameter
      const currentPath = window.location.pathname;
      const isLoginPage = currentPath === '/login' || 
                         currentPath === '/company/login' || 
                         currentPath === '/company/signup';
      
      if (!isLoginPage) {
        // Determine which login page to redirect to based on the current path
        const isCompanyPath = currentPath.startsWith('/company');
        const redirectPath = isCompanyPath ? '/company/login' : '/login';
        window.location.href = `${redirectPath}?expired=true`;
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance; 